<template>
  <section class="cta-section animate-up delay-3">
    <div class="container">
      <div class="cta-card">
        <h2>{{ title }}</h2>
        <p><slot></slot></p>
        <router-link :to="buttonLink" class="btn-outline">
          {{ buttonText }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue';
defineProps(['title', 'buttonText', 'buttonLink']);
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.cta-section {
  padding-bottom: 100px;
}
.cta-card {
  background: #111;
  color: white;
  padding: 60px;
  border-radius: 12px;
  text-align: center;
}
.cta-card h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}
.cta-card p {
  margin-bottom: 35px;
  font-size: 1.1rem;
  color: #ccc;
  max-width: 600px;
  margin: 0 auto 35px;
}
.btn-outline {
  display: inline-block;
  border: 2px solid #b91c1c;
  color: white;
  padding: 15px 35px;
  text-decoration: none;
  font-weight: bold;
  border-radius: 4px;
  transition: all 0.3s;
}
.btn-outline:hover {
  background: #b91c1c;
}

@keyframes fadeInUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-up {
  animation: fadeInUp 0.8s ease forwards;
  opacity: 0;
}
.delay-3 {
  animation-delay: 0.6s;
}
</style>
